import { DateTime } from "luxon";
import { Properties, Constructor } from "./types";

export interface CourierModel extends Properties {}
export class CourierModel implements Properties {
  constructor(args: Constructor) {
    Object.assign(this, args);
  }

  static fromResponse(response: Record<string, any>) {
    return new CourierModel({
      id: response.id,
      name: response.name,
      code: response.code,
      minWeight: parseInt(response.min_weight),
      maxWeight: parseInt(response.max_weight),
      createdAt: DateTime.fromISO(response.created_at),
      updatedAt: DateTime.fromISO(response.updated_at),
      deletedAt: response.deleted_at && DateTime.fromISO(response.deleted_at),
    });
  }
}
